const service = {
  service: {
    transOil: {
      title: 'x-label:workflow2.service.hydraulic trans oil.hydraulic trans oil',
      screens: [
        {
          data: [
            {
              label: 'x-label:workflow2.service.hydraulic trans oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow2.service.hydraulic trans oil.hrs',
              num: '463.2',
              center: true
            }
          ]
        },
        {
          data: [
            {
              label: 'x-label:workflow2.service.hydraulic trans oil.screen2.service history :'
            },
            {
              num: '250'
            }
          ]
        }
      ],
      routes: {
        left: 'service/exit',
        right: 'service/engine-oil'
      }
    },
    engineOil: {
      title: 'x-label:workflow2.service.engine oil.engine oil',
      screens: [
        {
          data: [
            {
              label: 'x-label:workflow2.service.engine oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow2.service.engine oil.hrs',
              num: '18.2',
              center: true
            }
          ]
        },
        {
          data: [
            {
              label: 'x-label:workflow2.service.engine oil.screen2.service history :'
            },
            {
              num: '5 , 105 , 205'
            }
          ]
        }
      ],
      routes: {
        left: 'service/trans-oil',
        right: 'service/current-error'
      }
    },
    currentError: {
      title: 'x-label:workflow2.service.current error.current error',
      screens: [
        {
          data: [
            {
              label: '@invisible'
            },
            {
              label: 'x-label:workflow2.service.current error.no errors',
              center: true
            }
          ]
        },
        {}
      ],
      routes: {
        left: 'service/engine-oil',
        right: 'service/input-status'
      }
    },
    inputStatus: {
      title: 'x-label:workflow2.service.status of inputs.status of inputs',
      screens: [
        {
          wrapContent: true,
          flowType: 'gas',
          data: [
            {
              label: 'x-label:workflow2.service.status of inputs.pto switch'
            },
            {
              label: 'x-label:workflow2.service.status of inputs.neutral',
              invert: true
            },
            {
              label: 'x-label:workflow2.service.status of inputs.oil pressure'
            },
            {
              label: 'x-label:workflow2.service.status of inputs.brake',
              invert: true
            },
            {
              label: 'x-label:workflow2.service.status of inputs.seat',
              invert: true
            },
            {
              label: 'x-label:workflow2.service.status of inputs.engine comm',
              invert: true
            }
          ]
        },
        {
          data: [
            {
              label: 'x-label:workflow2.service.status of inputs.screen2.system voltage',
              num: '14.7V'
            },
            {
              label: 'x-label:workflow2.service.status of inputs.screen2.fuel sender',
              num: '4.5'
            }
          ]
        },
        {
          title: 'x-label:workflow2.service.status of inputs.screen3.status of temp inputs',
          data: [
            [
              { label: 'x-label:workflow2.service.status of inputs.screen3.c', num: '230' },
              { label: 'x-label:workflow2.service.status of inputs.screen3.f', num: '\xa0110' },
              { label: 'x-label:workflow2.service.status of inputs.screen3.engine temp' }
            ]
          ]
        },
      ],
      routes: {
        left: 'service/current-error',
        right: 'service/output-status'
      }
    },
    outputStatus: {
      title: 'x-label:workflow2.service.status of outputs.status of outputs',
      screens: [
        {
          data: [
            {
              label: 'x-label:workflow2.service.status of outputs.module comm',
              invert: true
            },
            {
              label: 'x-label:workflow2.service.status of outputs.pto output'
            },
            {
              label: 'x-label:workflow2.service.status of outputs.alarm output'
            },
            {
              label: 'x-label:workflow2.service.status of outputs.starter output'
            }
          ]
        },
        {
          data: [
            {
              label: 'x-label:workflow2.service.status of outputs.screen2.engine shutdown output'
            },
            {
              label: 'x-label:workflow2.service.status of outputs.screen2.engine speed command',
              num: '9.9V'
            }
          ]
        }
      ],
      routes: {
        left: 'service/input-status',
        right: 'service/machine-info'
      },
    },
    machineInfo: {
      title: 'x-label:workflow2.service.machine information.machine information',
      screens: [
        {
          data: [
            {
              label: 'x-label:workflow2.service.machine information.model',
              num: 'no. LZS850EKA604W0',
              reverseOrder: true
            },
            {
              label: 'x-label:workflow2.service.machine information.serial',
              num: 'no. 400064931',
              reverseOrder: true
            }
          ]
        }
      ],
      routes: {
        left: 'service/output-status',
        right: 'service/module-info'
      }
    },
    moduleInfo: {
      title: 'x-label:workflow2.service.module information.module information',
      screens: [
        {
          data: [
            {
              label: 'x-label:workflow2.service.module information.ldu',
              num: '\xa0'
            },
            {
              label: 'x-label:workflow2.service.module information.hw version',
              num: '000000X'
            },
            {
              label: 'x-label:workflow2.service.module information.sw version',
              num: '000-\xa0000'
            }
          ]
        },
        {
          data: [
            {
              label: 'x-label:workflow2.service.module information.screen2.mcu',
              num: '\xa0'
            },
            {
              label: 'x-label:workflow2.service.module information.screen2.hw version',
              num: '000000X'
            },
            {
              label: 'x-label:workflow2.service.module information.screen2.sw version',
              num: '000-\xa0000'
            }
          ]
        }
      ],
      routes: {
        left: 'service/machine-info',
        right: 'service/exit'
      }
    },
    exit: {
      title: 'x-label:workflow2.service.exit.exit',
      routes: {
        left: 'service/module-info',
        right: 'service/trans-oil'
      }
    }
  }
};

export default service;



// WEBPACK FOOTER //
// ./src/screens/data/flow2/service.js